export default __webpack_public_path__ + "3826fa1cb2348dd93948a50cbd2b8fb6.woff2";